<template>
  <v-container fluid>
    <div v-if="carregando">
      <div class="mt-2 text-center" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item" class="mb-2"></v-skeleton-loader>
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </div>
    </div>
		<div v-else>
			<div class="text-h1 mb-4">
				Financiamentos
      </div>
			<v-tabs
        next-icon="chevron_right"
        prev-icon="chevron_left"
        show-arrows
        class="ui-tabs"
        v-model="tabs">
        <v-tab>
          <v-icon>clipboard-text</v-icon> Listagem
        </v-tab>
        <v-tab>
          <v-icon>assessment</v-icon> Gráficos
        </v-tab>
      </v-tabs>
			<v-tabs-items v-model="tabs" class="relatorio_height">
				<v-tab-item class="px-1 pb-1">
					<v-data-table
            disable-sort
            disable-pagination
            disable-filtering
            hide-default-footer
						:headers="headers"
						:items="dados"
						:search="search"
						loading-text="Carregando... Por favor aguarde"
						:loading="carregando"
						class="elevation-1 base_table mt-4"
						:header-props="{
							sortIcon: 'north',
						}"
					>
            <template v-slot:top>
              <v-row align="center" justify="space-between" class="mb-2">
                <v-col cols="12" md="11">
                  <v-row no-gutters align="center">
                    <v-col cols="12" class="pt-0" md="4">
                      <VueCtkDateTimePicker
                        position="bottom"
                        v-on:callback="changeDates"
                        v-model="data_entrada"
                        class="date-picker"
                        locale="pt-BR"
                        :no-header="true"
                        :no-value-to-custom-elem="true"
                        :overlay="true"
                        :range="true"
                        :formatted="'L'"
                        :format="'YYYY-MM-DD'"
                        color="#004A93"
                        :dark="$vuetify.theme.dark"
                        button-color="#004A93"
                        :custom-shortcuts="labels"
                        :no-button="true"
                        :noClearButton="true"
                        :auto-close="true"
                        :loading="loadingSearch"
                        :disabled="loadingSearch"
                        :submit="retornoData()"
                      >
                        <v-btn class="px-2 ui-search_btn w-100" elevation="0" v-ripple="{ class: `success--text` }">
                          <b class="text">
                            Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                          </b>
                        </v-btn>
                      </VueCtkDateTimePicker>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-form @submit.prevent="applyFilter()">
                        <v-text-field
                          class="ml-2"
                          clearable
                          hide-details=""
                          clear-icon="close"
                          v-model="search"
                          outlined
                          label="Busca"
                          @click:clear="limparBusca()"
                        ></v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0" v-if="$root.Permissions.admin()">
                      <v-autocomplete
                        class="ml-2"
                        :menu-props="{ offsetY: true}"
                        v-model="distribuidor"
                        :items="distribuidores"
                        hide-details=""
                        clearable
                        clear-icon="close"
                        label="Distribuidor"
                        append-icon="expand_more"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0" v-if="!$root.Permissions.integrator()">
                      <v-autocomplete
                        class="ml-2"
                        :menu-props="{ offsetY: true}"
                        v-model="integrador"
                        :items="integradores"
                        hide-details=""
                        clearable
                        clear-icon="close"
                        label="Integrador"
                        append-icon="expand_more"
                        outlined
                        @change="applyFilter()"
                        @click:clear="applyFilter()"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="1" class="text-right">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="exportPdf()">
                        <v-icon large color="primary">
                          print
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Imprimir relatório</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
					</v-data-table>
				</v-tab-item>
				<v-tab-item class="px-1 pb-1">
					<graficos-relatorio></graficos-relatorio>
				</v-tab-item>
			</v-tabs-items>
		</div>
  </v-container>
</template>
<script>
import Api from '@API'
import GraficosRelatorio from '../GraficosRelatorio.vue'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    GraficosRelatorio,
    VueCtkDateTimePicker
  },
  data () {
    return {
      headers: [
        {
          text: 'ID do Cliente',
          align: 'start',
          value: 'cliente.cli_id'
        },
        { text: 'Cliente', value: 'cliente.cli_nome' },
        { text: 'Telefone', value: 'cliente.cli_telefone' },
        { text: 'Celular', value: 'cliente.cli_celular' },
        { text: 'CEP', value: 'orc_cep' },
        { text: 'Estado', value: 'orc_uf' },
        { text: 'Cidade', value: 'orc_cidade' },
        { text: 'Data', value: 'orc_criado_em' },
        { text: 'Modalidade Tarifária', value: 'orc_modalidade_tarifaria' },
        { text: 'Padrão de Entrada', value: 'orc_entrada_padrao' },
        { text: 'Consumo mensal', value: 'orc_consumo_mensal' },
        { text: 'Tipo de instalação', value: 'orc_tipo_instalacao' },
        { text: 'Tipo de Estrutura', value: 'orc_tipo_estrutura' },
        { text: 'Potência', value: 'orc_potencia' },
        { text: 'Potência do módulo', value: 'orc_potencia_modulo' },
        { text: 'Preço total', value: 'orc_total' },
        { text: 'Quantidade', value: 'orc_produtos_quantidade' }
      ],
      search: '',
      loadingSearch: false,
      de: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().subtract(90, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      statuses: [
        {
          text: 'Aberta',
          color: 'blue',
          value: 1
        },
        {
          text: 'Perdida',
          color: 'red',
          value: 2
        },
        {
          text: 'Fechada',
          color: 'green',
          value: 3
        }
      ],
      colors: {
        Aberta: 'blue',
        Perdida: 'red',
        Fechada: 'green',
        Baixa: 'red',
        Média: 'orange',
        Alta: 'green'
      },
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      tiposEstrutura: [],
      status: null,
      distribuidorAnterior: null,
      loadingDistribuidores: false,
      distribuidores: [],
      distribuidor: null,
      loadingIntegradores: false,
      integradores: [],
      integrador: null,
      integradorAnterior: null,
      funis: [],
      etapas: [],
      loadingEtapas: false,
      etapa: null,
      options: {},
      tabs: 0,
      carregando: false,
      relatorio: {},
      dados: [],
      dadosExport: []
    }
  },
  methods: {
    loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.status) this.status = Number(filters.status)

      this.loadFunctions()
    },
    loadFunctions () {
      this.getTiposEstrutura()
      this.getIntegrators(this.distribuidor)
      this.getDistributors()
      this.getRelatorio()
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      this.loading = true

      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.status ? { status: this.status } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }

      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getRelatorio()
    },
    async getRelatorio () {
      this.carregando = true
      let parametros = `?de=${this.de}&ate=${this.ate}`

      if (this.search) parametros += `&busca=${this.search}`
      if (this.status) parametros += `&status=${this.status}`
      if (this.distribuidor && !this.integrador) parametros += `&distribuidor=${this.distribuidor}`
      if (this.integrador) parametros += `&integrador=${this.integrador}`
      if (this.etapa) parametros += `&etapa=${this.etapa}`

      await Api.get(`relatorios/orcamentos-gerados${parametros}`)
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              info.push({
                ...item,
                orc_cep: this.formataCEP(item.orc_cep),
                orc_criado_em: this.$root.Formatter.formatDate(item.orc_criado_em, 'DD/MM/YYYY'),
                orc_total: this.retornaValor(item.orc_total),
                orc_consumo_mensal: this.retornaDecimal(item.orc_consumo_mensal) + ' kWh',
                orc_potencia: this.retornaDecimal(item.orc_potencia) + ' kWp',
                orc_potencia_modulo: this.retornaDecimal(item.orc_potencia_modulo) + ' W',
                orc_tipo_instalacao: this.retornaTipoInstalacao(item.orc_tipo_instalacao),
                orc_entrada_padrao: this.padroes[item.orc_entrada_padrao - 1].text,
                orc_modalidade_tarifaria: this.modalidades[item.orc_modalidade_tarifaria - 1].text,
                orc_tipo_estrutura: this.retornaTipoEstrutura(item.orc_tipo_estrutura)
              })
            })
          }
          this.dados = info
          this.carregando = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o relatório!',
            color: 'error'
          })
        })
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.tie_nome,
                value: item.tie_id
              })
            })
            this.tiposEstrutura = info
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome
              })
            })
            this.distribuidores = info
          }
        })
    },
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações') cabecalhos.push(header)
      })
      return cabecalhos
    },
    async exportPdf () {
      let de = this.$root.Formatter.formatDate(this.de, 'DD/MM/YYYY')
      let ate = this.$root.Formatter.formatDate(this.ate, 'DD/MM/YYYY')

      this.$root.Export.PDF(this, {
        titulo: 'Orçamentos gerados',
        subtitulo: `Período ${de} até ${ate}`,
        tabela: {
          headers: this.headers,
          dados: this.dados
        }
      })
    },
    retornaValor (valor) {
      if (!valor) return 'R$ 0,00'
      return this.$root.Formatter.floatToMoney(valor)
    },
    retornaDecimal (valor) {
      if (!valor) return '0,00'
      return valor.toString().replace('.', ',')
    },
    retornaTipoInstalacao (tipo) {
      if (!tipo) return null
      let tipoSelecionado = this.tiposInstalacao[tipo - 1]
      return tipoSelecionado ? tipoSelecionado.text : null
    },
    retornaTipoEstrutura (tipo) {
      if (!tipo) return null
      let tipoSelecionado = this.tiposEstrutura.find(tipo => tipo.tie_id === tipo)
      return tipoSelecionado ? tipoSelecionado.tie_nome : null
    },
    formataCEP (cep) {
      if (!cep) return ''
      cep = cep.toString()
      cep = `${cep.substr(0, 5)}-${cep.substr(5)}`
      return cep
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>>.v-tabs-items {
  min-height: inherit!important;
}
.relatorio {
  &_chip {
    width: 80px;
    justify-content: center;
  }
  &_height {
    min-height: 80vh!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/financeiros/RelatorioFinanciamento.vue